import React, { Component } from "react";
import { connect } from "react-redux";

import { Overview, Cart, ErrorPage } from "./pages";
import { PartialMessage } from "./partial";
import disableBrowserBackButton from "disable-browser-back-navigation";
import CONFIG from "./config";
import { checkResize } from "./utils/functions";
import { pageActions, currenciesActions, metalsActions, configActions } from "./actions";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      kinds: {},
      makes: {}
    };
  }

  componentDidUpdate() {
    localStorage.removeItem("yesLoginRequested");
    if (this.props.pageStorage.refresh) {
      const dataRequest = this.props.configStorage.getRequestData("catalog");
      const dataAction = CONFIG.getShopConfig({
        edelmetall: metalsActions,
        sorten: currenciesActions
      });
      this.props.dispatch(dataAction.fetchListData(dataRequest));
      this.props.dispatch(pageActions.setOverviewPage())
    }
    if (this.props.appId && this.props.appId !== this.props.configStorage.getAppId()) {
      this.dispatch(configActions.setAppId(this.props.appId))
    }
  }

  async componentDidMount() {
    disableBrowserBackButton();
    checkResize();
  }

  render() {
    return (
      <div id={CONFIG.SHOP_ID} className="no-if6-changes">
        <h1 className="ser-appheadline">{CONFIG.SHOP_NAME + (this.props.configStorage.isAnkaufShop() ? "-Ankauf" : "-Bestellung")}</h1>
        <div className="bootstrap-iso"                  >
          {this.props.pageStorage.isVisible("overview")
            ?
            <Overview />
            : null
          }
          {this.props.pageStorage.isVisible("cart")
            ?
            <Cart />
            : null
          }
          {this.props.pageStorage.isVisible("error") || this.props.pageStorage.isVisible("deltaError")
            ?
            <ErrorPage />
            : null
          }
        </div>
        <PartialMessage />
      </div>
    );
  }
}

export default connect(store => {
  return {
    pageStorage: store.pageStorage,
    configStorage: store.configStorage
  };
})(Home);
